/**
 * Generate a UUID v4
 */
export const uuid = (): string => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback implementation for older browsers
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * Check if the current browser is Internet Explorer
 * Note: IE is deprecated and this function will likely always return false in modern environments
 */
export const isIe = (): boolean => {
    if (!window?.navigator) {
        return false;
    }

    const userAgent = window.navigator.userAgent;
    return userAgent.includes('MSIE') || userAgent.includes('Trident/');
};

/**
 * Get the current environment
 */
export const getEnvironment = (): string => {
    if (typeof process !== 'undefined' && process.env) {
        return process.env.NODE_ENV || 'production';
    }
    return 'production';
};

/**
 * Remove HTML tags from a string
 */
export const stripHtml = (html: string): string => {
    if (typeof html !== 'string') {
        return '';
    }

    // Create a temporary div to parse HTML and extract text content
    if (typeof document !== 'undefined') {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    // Fallback regex for server-side or when document is not available
    return html.replace(/<[^>]*>/g, '');
};

/**
 * Sort a list/array
 */
export const sortList = <T>(
    list: Array<T>,
    compareFn?: (a: T, b: T) => number,
): Array<T> => {
    return [...list].sort(compareFn);
};
